import axios from 'axios/index'

const namespaced = true

const state = {
  opfOptions: []
}
const getters = {}
const actions = {
  getOpfs ({ commit }) {
    return axios.get('/api/private/v4.0/list/opfs/')
    .then(response => {
      commit('setOpfOptions', response.data)
    })
    .catch(error => {
      console.log(error)
    })
  }
}
const mutations = {
  setOpfOptions (state, data) {
    state.opfOptions = data
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
